import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generateTablePdf = ({ title = "Title", subtitle = "subtitle", rows, tableTitle = "Table title", table = { head: [], body: [], foot: [] }, signature = '', filename }) => {
    import("./font").then(fontM => {
        const doc = new jsPDF("landscape");

        doc.addFileToVFS('Mulish-Regular.ttf', fontM.default);
        doc.addFont('Mulish-Regular.ttf', 'Mulish', 'normal');
        doc.setFont('Mulish', 'normal');
        doc.setTextColor('#333');

        //Heading
        doc.setFontSize(14);
        doc.text(title, 5, 10);

        //Subheading
        doc.setFontSize(10);
        doc.text(subtitle, 5, 16);

        if (rows) {
            doc.autoTable({
                head: [rows.map(item => item.title)],
                foot: [rows.map(item => item.text)],
                theme: 'plain',
                styles: {
                    font: 'Mulish',
                    fontStyle: 'normal',
                    textColor: [51, 51, 51],
                    cellPadding: 0
                },
                headStyles: {
                    fontSize: 8,
                    minCellHeight: 5
                },
                footStyles: {
                    fontSize: 14,
                },
                margin: 5,
                startY: 24
            })
        }

        doc.setDrawColor(204, 204, 204);
        doc.setLineWidth(0.1);
        doc.line(5, rows ? 40 : 21, 292, rows ? 40 : 21);

        doc.setFontSize(8);
        doc.text(tableTitle, 5, rows ? 48 : 28);

        doc.autoTable({
            head: table.head,
            body: table.body,
            foot: table.foot,
            showFoot: 'lastPage',
            theme: 'plain',
            styles: {
                font: 'Mulish',
                fontStyle: 'normal',
                fontSize: 8,
                textColor: [51, 51, 51],
                lineColor: [204, 204, 204],
                lineWidth: 0.1
            },
            headStyles: {
                fillColor: [248, 248, 248],
            },
            footStyles: {
                fillColor: [248, 248, 248],
            },
            margin: 5,
            startY: rows ? 52 : 31
        });

        if (signature) {
            doc.setFontSize(8);
            doc.text(signature, 220, doc.lastAutoTable.finalY + 20);
            doc.line(220, doc.lastAutoTable.finalY + 30, 280, doc.lastAutoTable.finalY + 30);
        }

        doc.save(`${filename}.pdf`)
    });
};

export const parseDataToPDFBody = (data, selector) => data.reduce((acc, curr) => {
    return [
        ...acc,
        selector(curr)
    ];
}, []);